import styled from 'styled-components';
import {
  screenSize,
  whiteColor,
  appFontColor,
  mediumFont,
  primaryColor,
  regularFont,
} from '@app/styles';

type Props = {
  disabled?: boolean;
};
export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  @media (${screenSize.tablet}) {
    display: block;
  }
`;
export const InnerContainer = styled.div`
  width: 100%;
  position: relative;
  margin: 0 auto;
  overflow-x: hidden;
  padding: 60px 15px 15px;
  position: relative;
  height: calc(100vh - 65px);
  overflow-y: auto;
  @media (${screenSize.tablet}) {
    padding: 0px;
    width: 810px;
    height: 870px;
    display: flex;
    margin: 95px auto 40px;
    justify-content: flex-end;
    flex-direction: column;
    background: ${whiteColor};
    border-radius: 8px;
    box-shadow: rgb(100 112 119 / 20%) 0px 5px 10px 0px;
    input {
      border-color: #dee0e8;
    }
  }
`;
export const Row = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    padding: 5px 15px 0;
  }
`;
export const RowItem = styled.div`
  width: 100%;
  position: relative;
  margin: 25px 0;
  @media (${screenSize.tablet}) {
    width: 50%;
    padding: 0 15px;
    margin: 0;
  }
`;
export const UserRole = styled.div`
  width: 100%;
  position: relative;
  margin: 25px 0;
  @media (${screenSize.tablet}) {
    width: 50%;
    padding: 0 15px;
    margin: 0;
    margin-bottom: 20px;
  }
`;
export const SelectItem = styled.div`
  width: 100%;
  position: relative;
  margin: 25px 0;
  @media (${screenSize.tablet}) {
    width: 50%;
    padding: 0 15px;
    height: 90px;
    margin: 0;
  }
`;
export const Item = styled.div`
  width: 100%;
  position: relative;
  margin: 25px 0;
  @media (${screenSize.tablet}) {
    width: 100%;
    padding: 0 15px;
    margin: 0;
  }
`;
export const Heading = styled.div`
  text-align: center;
  padding: 15px;
  font-size: 21px;
  font-family: Noto Serif;
  color: rgb(58, 67, 94);
  ${mediumFont};
  @media (${screenSize.tablet}) {
    border-bottom: 1px solid #edeff3;
    height: 60px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const Footer = styled.div`
  border-top: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  @media (${screenSize.tablet}) {
    border-top: 2px solid #edeff3;
    padding: 0 20px;
    height: 88px;
  }
`;
export const ButtonContainer = styled.div`
  width: 100%;
  ${({ disabled }: Props) => {
    if (disabled) {
      return `
          button{
            background-color:#ccc;
            pointer-events:none;
          }
      `;
    }
  }}
  @media (${screenSize.tablet}) {
    width: 150px;
  }
`;
export const CancelButton = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    display: block;
  }
`;
export const Terms = styled.p`
  font-size: 15px;
  color: #6b6f8c;
  line-height: 26px;
  margin: 20px 0 0;
  padding: 20px 0;
  border-top: 1px solid #bdc3c7;
  a {
    font-size: inherit;
    ${regularFont}
  }
  @media (${screenSize.tablet}) {
    font-size: 14px;
    padding: 0 30px;
    border-top: 0;
    margin: 0px 0 44px;
  }
`;
export const Rule = styled.p`
  font-size: 15px;
  color: color: #6B6F8C;
  line-height: 17px;
  margin: 20px 0 0;
  padding: 0;
  display: flex;
  opacity:0.5;
  ${regularFont}
  @media (${screenSize.tablet}) {
    padding: 0 30px;
    border-top: 0;
    margin: 10px 0;
    text-align: center;
  }
`;
export const Text = styled.p`
  color: ${appFontColor};
  text-align: center;
  a {
    font-size: inherit;
  }
  @media (${screenSize.tablet}) {
    display: none;
  }
`;

export const ErrorMessage = styled.p`
  font-size: 14px;
  color: #ec4160;
  margin: 0;
  position: absolute;
  bottom: -22px;
  @media (${screenSize.tablet}) {
    bottom: 0;
  }
`;
export const UserRoleErrorMessage = styled.p`
  font-size: 14px;
  color: #ec4160;
  margin: 0;
  position: absolute;
  bottom: -22px;
  @media (${screenSize.tablet}) {
    bottom: 20;
  }
`;
export const SavingIndicator = styled.div`
  position: absolute;
  right: 30px;
  top: 15px;
  svg {
    path {
      fill: ${whiteColor};
    }
  }
  @media (${screenSize.tablet}) {
    left: 30px;
    right: auto;
    top: 35px;
    svg {
      path {
        fill: ${primaryColor};
      }
    }
  }
`;
export const Label = styled.label`
  color: #818589;
  font-size: 0.8rem;
  ${mediumFont}
  line-height: 21px;
  padding: 5px 0;
  @media (${screenSize.tablet}) {
    text-align: left;
    width: 100%;
  }
`;

export const CustomLabel = styled.label`
  font-size: 15px;
  color: #0f1d2a;
  opacity: 0.5;
  text-align: left;
  line-height: 21px;
  ${mediumFont}
`;
